module.exports = __webpack_public_path__ + "images/30f565f74e8b0c2a25f9d6abd3a8692b-illu_close.png";